export default __webpack_public_path__ + "static/media/review4.21b949d2.jpg";